import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from '../config/firebase'

const login = async (email, password) => {
  await signInWithEmailAndPassword(auth, email, password);
};

const logout = async () => {
  await signOut(auth);
};

// eslint-disable-next-line no-async-promise-executor
const profile = () => new Promise(async (res) => {
    auth.onAuthStateChanged(async (user) => {
    if (user) {
      const docSnap = await getDoc(doc(db, 'users', user.uid));
      res({
        uid: user.uid,
        email: user.email,
        name: docSnap.exists() && docSnap.data().name ? docSnap.data().name : undefined,
        account: docSnap.exists() && docSnap.data().account ? docSnap.data().account : undefined,
        role: docSnap.exists() && docSnap.data().role ? docSnap.data().role : undefined,
      });
    } else {
      res(false);
    }
  });
});
const funcs = {
  login,
  logout,
  profile,
};

export default funcs;
